import { render } from "./CarouselButtonListingModal.vue?vue&type=template&id=656587c4&scoped=true"
import script from "./CarouselButtonListingModal.vue?vue&type=script&lang=ts"
export * from "./CarouselButtonListingModal.vue?vue&type=script&lang=ts"

import "./CarouselButtonListingModal.vue?vue&type=style&index=0&id=656587c4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-656587c4"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QList,QItem,QItemSection,QIcon,QSpace});
